import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Typography, ConfigProvider } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import useAuth from '../hooks/useAuth';
import { clearLocalStorage, locusTokenOverrides } from '../static/common';
import KeycloakServices from '../Keycloak-config';
import { ErrorImg } from '../icons/ErrorImg';
import { Routes, StorageKeys } from '../constants';

const { Title } = Typography;

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
`;

const Container = styled(FlexColumn)`
  gap: 4rem;
  padding: 0;
  height: 100vh;
  background: radial-gradient(circle at center, #376A8A0F 37%, transparent 0%);
  text-align: center;

  && .ant-typography {
    margin: 0;
    color: #025181;
  }
  && h1 {
    font-size: 4rem;
  }
  && h3 {
    font-weight: 400;
  }
  && svg {
    width: 100%;
    height: 16%;
  }
`;

const Box = styled(FlexColumn)`
  flex-direction: row;
  width: 100%;

  && button {
    width: 7rem;
    min-width: fit-content;
    border-color: #025181;
    border-radius: 3px;
  }
  && button:first-child:hover {
    background-color: #025181;
    color: #FFFFFF;
  }
`;

const ErrorPage = () => {
  const { t } = useTranslation();
  const { changeClientId, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    user && ((location?.key === 'default') ? navigate(Routes.home) : navigate(-1));
  }, []);

  if (user) {
    return <></>;
  }

  return (
    <ConfigProvider
      theme={{
        token: {
          // Seed Token
          colorPrimary: locusTokenOverrides.colorPrimary,
          colorTextBase: locusTokenOverrides.colorPrimary,
        }
      }}
    >
      <Container>
        <FlexColumn>
          <span>
            <Title level={1}>{t('general.siteUnderMaintenance')}</Title>
            <Title level={3}>{t('general.optimizingBetterExperience')}</Title>
          </span>
          <Box>
            <Button
              size="large"
              color="default"
              loading={loading}
              onClick={() => {
                setLoading(true);
                changeClientId(localStorage.getItem(StorageKeys.clientId) ?? null);
              }}
            >
              {t('general.reload')}
            </Button>
            <Button
              type="primary"
              size="large"
              color="default"
              loading={loading}
              onClick={() => {
                setLoading(true);
                clearLocalStorage();
                KeycloakServices.logout();
              }}
            >
              {t('general.logout')}
            </Button>
          </Box>
        </FlexColumn>
        <ErrorImg />
      </Container>
    </ConfigProvider>
  );
};

export default ErrorPage;
